module.exports = __webpack_public_path__ + "static/media/add_personalised_button.8cae287f.png";